import React from 'react';
import { Image} from 'react-native';
import type { PollCampaignProps } from '../../types';
import { Icons } from '../../Components';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type CampaignHeaderProps = {
    poll_campaign:PollCampaignProps,
    onBack?:() => void,
    onSharePollCampaign:(pc:PollCampaignProps) => void
}

const CampaignHeader = ({ poll_campaign, onSharePollCampaign, onBack }:CampaignHeaderProps) => {
    const Colors = useColors();
    return (
        <View>
            <View type='header' nativeID="competition_header" style={{ flexDirection:'row', alignItems:'center', padding:20, borderBottomWidth:1 }}>
                {onBack ?
                <Button
                    transparent
                    style={{ paddingLeft:0, paddingRight:20 }}
                >
                    <Icons.ChevronIcon direction='left' color={Colors.text.h1} size={10} />
                </Button>
                :<></>}
                <View transparent>
                    <Image
                        source={{ uri: poll_campaign.campaign_image?.url ?? 'https://res.cloudinary.com/hoabts6mc/image/upload/v1649737862/be_logo_jte2ux.webp' }}
                        style={{ height:50, width:50, borderRadius:4, backgroundColor:Colors.text.white, padding:5 }}
                        resizeMode="cover"
                    />
                </View>
                <View transparent style={{ flex:1, marginLeft:10, marginRight:10 }}>
                    <Text theme='h1'>{poll_campaign.name}</Text>
                </View>
                <Button onPress={() => onSharePollCampaign(poll_campaign)}>
                    <Icons.ShareIcon color={Colors.text.h1} size={14} />
                </Button>
            </View>
        </View>
    )
}

export default CampaignHeader